import React, { useContext, useEffect, useState, useRef } from 'react';
import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';
import { Input, RadioGroup, TextArea } from '@progress/kendo-react-inputs';
import { Button } from '@progress/kendo-react-buttons';
import PublishSwitch from '../publishSwitch';
import DeleteFormItem from '../../DeleteFormItem';
import { LocalizationContext } from '../../../contexts';
import Uploader, { uploaderTypes } from '../../Uploader';
import './index.scss';
import '../forms.scss';

export default function TextImageBanner({ data, onUpdate, validator, settingsData = {}, ...rest }) {
  const emptyItem = useRef({ name: "", title: "", text: "", image: "", image_mobile: "", animate_json: "", animate_json_mobile: "", link: "", link_target: "_top", has_button: false, button: false, isPublish: false });
  const generalEmptyItem = useRef({ ...emptyItem.current });
  const personalEmptyItem = useRef({ ...emptyItem.current });
  const buttonEmptyItem = { text: "", link: "", link_target: "_top" }
  const [compData, setCompData] = useState({});
  //const [validateMode, setValidateMode] = useState(false);
  const [contentSelect, setContentSelect] = useState(0);
  const [localization] = useContext(LocalizationContext);
  const { labels } = localization;
  const bannerType = settingsData.type || ['general'];

  const userTypes = [ //for Personal tab
    { id: "teacher", text: localization.labels.bannersManagement.userTypes.teacher },
    { id: "coordinator", text: localization.labels.bannersManagement.userTypes.coordinator, itemDisabled: true },
    { id: "director", text: localization.labels.bannersManagement.userTypes.director, itemDisabled: true },
  ]
  //const current_userType = userTypes.find(d => d.id === userType);

  validator.current = () => {
    return true;
  };

  useEffect(() => {
    const defaultData = { general: [{ ...generalEmptyItem.current }], personal: [{ ...emptyItem.current }] };
    const startCompData = { ...defaultData, ...JSON.parse(JSON.stringify(data ? data : {})) };
    if (!startCompData.general || startCompData.general.length === 0) {
      startCompData.general = [{ ...generalEmptyItem.current }];
    }
    if (!startCompData.personal || startCompData.personal.length === 0) {
      startCompData.personal = [{ ...personalEmptyItem.current }];
    }
    setCompData(startCompData);
  }, [data]);

  const handleContentSelect = (e) => {
    setContentSelect(e.selected);
  }

  const handleDeleteClick = (itemIdToDelete, type) => {
    const newCompData = { ...compData };
    if (newCompData[type].length > 1) {
      newCompData[type].splice(itemIdToDelete, 1);
    } else {
      if (type === 'general') {
        newCompData[type] = [{ ...generalEmptyItem.current }]
      } else {
        newCompData[type] = [{ ...personalEmptyItem.current }]
      }
    }
    setCompData(newCompData);
    onUpdate(newCompData);
  };

  const handleAddClick = (type) => {
    const newCompData = { ...compData };
    if (type === 'general') {
      newCompData[type] = [...compData[type], { ...generalEmptyItem.current }];
    } else {
      newCompData[type] = [...compData[type], { ...personalEmptyItem.current }];
    }
    setCompData(newCompData);
  };

  const updateItem = (type, i, newData) => {
    const newCompData = { ...compData };
    newCompData[type][i] = { ...compData[type][i], ...newData };
    setCompData(newCompData);
    onUpdate(newCompData);
  }

  const updateItemHasButton = (type, i, newData) => {
    const newCompData = { ...compData };
    newCompData[type][i] = { ...compData[type][i], ...newData };
    if (newData.has_button) {
      newCompData[type][i].button = { ...buttonEmptyItem }
    } else {
      newCompData[type][i].button = false
    }

    setCompData(newCompData);
    onUpdate(newCompData);
  }

  const updateItemButton = (type, i, newData) => {
    const newCompData = { ...compData };
    newCompData[type][i].button = { ...compData[type][i].button, ...newData };
    setCompData(newCompData);
    onUpdate(newCompData);
  }
  const isNotOneEmptyItem = (type) => {
    return (compData[type].length !== 1 || JSON.stringify(compData[type][0]) !== JSON.stringify(type === "general" ? generalEmptyItem.current : personalEmptyItem.current));
  }

  const showRequired = (type, item, requiredField) => {
    let noRequiredField;
    if (requiredField.length > 1) {
      if (requiredField[0] === 'has_button') {//button fields
        noRequiredField = item[requiredField[0]] && !item.button[requiredField[1]];
      } else {//images or animation
        noRequiredField = (!item[requiredField[0]] && !item[requiredField[1]]) || (item[requiredField[0]] && item[requiredField[1]])
      }
    } else {
      noRequiredField = !item[requiredField[0]];
    }

    return (isNotOneEmptyItem(type) && noRequiredField)
  }

  // const validateForm = () => {
  //   const emptyGeneralItem = compData && compData.general && compData.general.length === 1 && JSON.stringify(compData.general[0]) === JSON.stringify(generalEmptyItem.current);
  //   const emptyPersonalItem = compData && compData.personal && compData.personal.length === 1 && JSON.stringify(compData.personal[0]) === JSON.stringify(personalEmptyItem.current);
  //   if (emptyGeneralItem && emptyPersonalItem) {
  //     setValidateMode(false);
  //   } else {
  //     const formNotValidGeneral = !emptyGeneralItem && compData.general.some(item => !item.text || (!item.image && !item.animate_json) || (item.image && item.animate_json) || (!item.image_mobile && !item.animate_json_mobile) || (item.image_mobile && item.animate_json_mobile) || (item.has_mobile && (!item.button.text || !item.button.link)));
  //     const formNotValidPersonal = !emptyPersonalItem && compData.personal.some(item => !item.text || (!item.image && !item.animate_json) || (item.image && item.animate_json) || (!item.image_mobile && !item.animate_json_mobile) || (item.image_mobile && item.animate_json_mobile) || (item.has_mobile && (!item.button.text || !item.button.link)));
  //     if (formNotValidGeneral || formNotValidPersonal) {
  //       setValidateMode(true);
  //       alert('בדקו שכל הטאבים במדור תקינים');
  //       return false;
  //     }
  //   }
  //   return true;
  // }

  const canPublish = (item) => {
    if (!item.title || !item.text ||
      !(item.image || item.animate_json) ||
      !(item.image_mobile || item.animate_json_mobile)) {
      return false;
    }

    if (item.has_button && item.button) {
      if (!item.button.link || !item.button.text)
        return false;
    }

    return true;
  };

  const showComponent = (tab) => {
    return <div className="form-content">
      <div className="form-items">
        {compData[tab]?.map((item, i) => {
          return (
            <React.Fragment key={i}>
              <div className="form-item">
                <div className="form-item__title">
                  {labels.pagesManagement.forms.item} {i + 1}
                  {isNotOneEmptyItem(tab) && <DeleteFormItem itemIdToDelete={i} type={tab} handleDeleteClick={handleDeleteClick} />}
                </div>
                <div className="form-field">
                  <label className="form-field__label">{labels.pagesManagement.forms.add_name} ({labels.pagesManagement.forms.wont_be_in_site})</label>
                  <Input name={'name'} value={item.name} onChange={({ value }) => updateItem(tab, i, { name: value })}></Input>
                </div>
                <div className="form-field">
                  <label className="form-field__label mandatory">{labels.pagesManagement.forms.add_title}</label>
                  <Input name={'title'} value={item.title} onChange={({ value }) => updateItem(tab, i, { title: value })}></Input>
                  {showRequired(tab, item, ['title']) && <div className="form-field__required">{labels.pagesManagement.forms.required}</div>}
                </div>
                <div className="form-field">
                  <label className="form-field__label mandatory">{labels.pagesManagement.forms.add_text}</label>
                  <TextArea name={'text'} value={item.text} onChange={({ value }) => updateItem(tab, i, { text: value })}></TextArea>
                  {showRequired(tab, item, ['text']) && <div className="form-field__required">{labels.pagesManagement.forms.required}</div>}
                </div>
                <div className="form-field">
                  <label className="form-field__label">{labels.pagesManagement.forms.add_pc_banner}</label>
                  <Uploader type={uploaderTypes.image} imageUrl={item.image} prefix={'textImageBanner'} onChange={(file) => { updateItem(tab, i, { image: file }) }} />
                </div>
                <div className="form-field separator"><label className="form-field__label">{labels.pagesManagement.forms.or}</label></div>
                <div className="form-field">
                  <label className="form-field__label">{labels.pagesManagement.forms.add_pc_animation}</label>
                  <Uploader type={uploaderTypes.animation} animationUrl={item.animate_json} prefix={'textImageBanner'} onChange={(file) => { updateItem(tab, i, { animate_json: file }) }} />
                  {showRequired(tab, item, ['image', 'animate_json']) && <div className="form-field__required">{labels.pagesManagement.forms.required_image_or_animation}</div>}
                </div>
                <div className="form-field">
                  <label className="form-field__label">{labels.pagesManagement.forms.add_mobile_banner}</label>
                  <Uploader type={uploaderTypes.image} imageUrl={item.image_mobile} prefix={'textImageBanner'} onChange={(file) => { updateItem(tab, i, { image_mobile: file }) }} />
                </div>
                <div className="form-field separator"><label className="form-field__label">{labels.pagesManagement.forms.or}</label></div>
                <div className="form-field">
                  <label className="form-field__label">{labels.pagesManagement.forms.add_mobile_animation}</label>
                  <Uploader type={uploaderTypes.animation} animationUrl={item.image_mobile} prefix={'textImageBanner'} onChange={(file) => { updateItem(tab, i, { animate_json_mobile: file }) }} />
                  {showRequired(tab, item, ['image_mobile', 'animate_json_mobile']) && <div className="form-field__required">{labels.pagesManagement.forms.required_image_or_animation}</div>}
                </div>
                <div className="form-field">
                  <label className="form-field__label inline">{labels.pagesManagement.forms.action_button}</label>
                  <RadioGroup data={[
                    { label: labels.pagesManagement.forms.without_button, value: false },
                    { label: labels.pagesManagement.forms.with_button, value: true }
                  ]}
                    layout='horizontal'
                    value={item.has_button}
                    onChange={({ value }) => {
                      updateItemHasButton(tab, i, { has_button: value });
                    }}
                  />
                </div>
                {item.has_button && item.button &&
                  <React.Fragment>
                    <div className="form-field">
                      <label className="form-field__label mandatory">{labels.pagesManagement.forms.add_button_text}</label>
                      <Input name={'buttonText'} value={item.button.text} onChange={({ value }) => updateItemButton(tab, i, { text: value })}></Input>
                      {showRequired(tab, item, ['has_button', 'text']) && <div className="form-field__required">{labels.pagesManagement.forms.required}</div>}
                    </div>
                    <div className="form-field">
                      <label className="form-field__label mandatory">{labels.pagesManagement.forms.add_link}</label>
                      <Input name={'buttonLink'} value={item.button.link} onChange={({ value }) => updateItemButton(tab, i, { link: value })}></Input>
                      <RadioGroup data={[
                        { label: labels.pagesManagement.forms.open_top, value: '_top' },
                        { label: `${labels.pagesManagement.forms.open_blank} (${labels.pagesManagement.forms.for_external_links})`, value: '_blank' }
                      ]}
                        layout='horizontal'
                        value={item.button['link_target']}
                        onChange={({ value }) => {
                          updateItemButton(tab, i, { link_target: value });
                        }}
                      />
                      {showRequired(tab, item, ['has_button', 'link']) && <div className="form-field__required">{labels.pagesManagement.forms.required}</div>}
                    </div>
                  </React.Fragment>
                }
                <PublishSwitch isPublish={item?.isPublish} canPublish={canPublish(item)}
                  updateItem={(event) => updateItem(tab, i, { isPublish: event.target.value })} />
              </div>
              {compData[tab].length - 1 === i && <div className="form-add"><Button primary={true} onClick={() => { handleAddClick(tab); }}>{labels.pagesManagement.forms.add_item}</Button></div>}
            </React.Fragment>)
        })}
      </div>
    </div>
  }

  return (
    <React.Fragment>
      <div className="form-message">
        {labels.pagesManagement.menu.home.text_image_banner}
      </div>
      <div className="form-content">
        <div className="form-tabs">
          {bannerType.includes('personal') && <TabStrip selected={contentSelect} onSelect={handleContentSelect} animation={false}>
            {userTypes.map((tab, i) => {
              return <TabStripTab key={i} title={tab.text}></TabStripTab>;
            })}
          </TabStrip>}
          {bannerType.map((tab, i) => {
            return <div key={i} className={`form-inner ${contentSelect === i ? "form-inner--active" : ""}`} data-tab={i}>
              {showComponent(tab)}
            </div>
          })}
        </div>
        {/* <div style={{ marginTop: 20 }}>{JSON.stringify(compData)}</div> */}
      </div>
    </React.Fragment>
  );
};